import { z } from 'zod';

export const customerFormSchema = z.object({
  first_name: z.string()
    .max(100, 'El nombre debe tener máximo 100 caracteres')
    .optional()
    .or(z.literal('')),
  last_name: z.string()
    .max(100, 'El apellido debe tener máximo 100 caracteres')
    .optional()
    .or(z.literal('')),
  company_name: z.string()
    .max(200, 'El nombre de empresa debe tener máximo 200 caracteres')
    .optional()
    .or(z.literal('')),
  codificacion: z.string()
    .max(100, 'La codificación debe tener máximo 100 caracteres')
    .optional()
    .or(z.literal('')),
  cif: z.string()
    .max(50, 'El CIF debe tener máximo 50 caracteres')
    .optional()
    .or(z.literal('')),
  email: z.string()
    .email('Correo electrónico inválido')
    .max(255, 'El correo debe tener máximo 255 caracteres')
    .optional()
    .or(z.literal('')),
  phone: z.string()
    .max(20, 'El teléfono debe tener máximo 20 caracteres')
    .optional()
    .or(z.literal('')),
  address: z.string()
    .max(500, 'La dirección debe tener máximo 500 caracteres')
    .optional()
    .or(z.literal('')),
  is_active: z.boolean().default(true),
  notes: z.string()
    .max(1000, 'Las notas deben tener máximo 1000 caracteres')
    .optional()
    .or(z.literal('')),
}).refine(
  (data) => data.first_name || data.company_name,
  {
    message: 'Debe proporcionar al menos un nombre o nombre de empresa',
    path: ['first_name'],
  }
);

export type CustomerFormData = z.infer<typeof customerFormSchema>;
